import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControl, FormHelperText, InputLabel, Select, Typography } from '@mui/material';

export default function FormSelect({ name, children, disabled, label, sublabel, size, helperStyles, displayValue, onSelectChange }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { error },
      }) => (
        <FormControl size={size} fullWidth variant="outlined">
          <InputLabel
            variant="outlined"
            size={size}
            id={`${name}-simple-select-standard-label`}
          >
            {label}
          </InputLabel>
          <Select
            displayEmpty={!label}
            variant="outlined"
            labelId={`${name}-simple-select-standard-label`}
            id={`${name}-simple-select-standard`}
            disabled={disabled}
            name={name}
            onChange={(e) => {
              onChange(e);
              onSelectChange?.(e.target.value);
            }}
            value={value || ''}
            onBlur={onBlur}
            inputRef={ref}
            error={!!error}
            size={size}
            label={label}
            renderValue={(selected) => {
              const toDisplay = displayValue !== undefined ? displayValue : value;
              if (toDisplay) {
                return toDisplay;
              }
              if (!label)
                return <Typography color="text.disabled" fontSize="14px">Selecciona tu respuesta</Typography>;
            }}
          >
            {children}
          </Select>
          <FormHelperText sx={{ ...helperStyles }} error={!!error}>{error?.message ? error.message : sublabel}</FormHelperText>
        </FormControl>
      )}
    />
  );
}

FormSelect.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};

FormSelect.defaultProps = {
  disabled: false,
};
